import './CSS/style.css';
import React, { useRef,useState,useEffect } from 'react';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import themeSettings from '../../../commons/styles/themeSettings.json';
import {
  FormUpdate,
  FormSubmission,
  getUserList,
  getRelatedTags,
  GetUseCase,
} from '../APICalls/FormCalls';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import { ANALYTICS, IPAddress } from '../../../commons/api';
import {
  Button,
  Form,
  Input,
  message,
  Select,
  Upload,
  Drawer,
  Tooltip,
  Badge
} from 'antd';
import StyledTable from '../../../commons/styles/table';
import { useNavigate } from 'react-router-dom';
import { StyledTab, LightTheme } from '../../../commons/styles/tab';
import CommentsForm from '../Details/CommentsForm';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import {
  EditOutlined,
  PlusOutlined,
  FieldTimeOutlined,
  UserOutlined,
  UploadOutlined,
  DownloadOutlined,
  CommentOutlined,
  SearchOutlined
} from '@ant-design/icons';

const { TextArea } = Input;

const APIList = {
  getList: `${ANALYTICS.PredictionGet}`,
  getListUsecase: `${ANALYTICS.UseCaseGet}`,
  getById: `${ANALYTICS.PredictionGetById}`,
  Create: `${ANALYTICS.UsecaseCreate}`,
  Update: `${ANALYTICS.UseCaseUpdate}`
};

const UseCase = (props) =>{

  const [formObject,setFormObject] = useState ({});
  const [predictionDatasource,setPredictionDatasource] = useState ([]);
  const [analysisDatasource,setAnalysisDatasource] = useState ([]);
  const [translationCache,setTranslationCache] = useState(props.translationCache || {});
  const [userProfile,setUserProfile] = useState(props && props.userProfile ? props.userProfile : {});
  const [useCaseModalVisible,setUseCaseModalVisible] = useState (false);
 // const [usecaseName,setUsecaseName] = useState ('');
  const [showusecasedownloadModal,setShowusecasedownloadModal] = useState (false);
  const [breadcrumbList,setBreadcrumbList] = useState([]);
  // const [lastBreadcrumb,setLastBreadcrumb] = useState([]);
  const [users,setUsers] = useState([]);
  const [analyticsId,setAnalyticsId] = useState('');
  // const [fileName,setFileName] = useState([]);
  const [searchText,setSearchText] =useState('');
  const [activeKey,setActiveKey] = useState('1');
  const [relatedTags,setRelatedTags] = useState('');
  const [searchedColumn,setSearchedColumn] =useState('');
  const [Type] = useState([]);
  const hForm = React.createRef();
  const myRef = useRef();
  const searchInputRef = useRef(null);
  const navigate = useNavigate();


  



  useEffect(() =>{
    getUsecaseInitialData();
  },[]);
  useEffect(() =>{
    if (
      translationCache !== props.translationCache ||
      props.userProfile !== userProfile
    ) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }
    if (props.location !== location) {
      getUsecaseInitialData();
    }
  },[translationCache,userProfile,location,props.translationCache,props.userProfile,props.location]);

 const getUsecaseInitialData = async () => {
    // let searchParams = new URLSearchParams(this.props.location.search);
    // let newParams = Object.fromEntries([...searchParams]);
    const pathSnippets = props.location.pathname
      .split(`/rubus/RubusAnalytics/usecase/`)
      .filter((i) => i);
    if (pathSnippets && pathSnippets[0]) {
      const useCaseLevel = pathSnippets[0].split('/').filter((i) => i);
      if (useCaseLevel && useCaseLevel[useCaseLevel.length - 1] !== 'New') {
        const formObject = await editList(useCaseLevel[useCaseLevel.length - 1]);

        if (formObject && formObject !== null) {
          hForm.current &&
            hForm.current.setFieldsValue({
              Title: formObject && formObject.Title,
              Id: formObject && formObject.Id,
              RelatedTags: formObject && formObject.RelatedTags,
              CreatedBy: formObject && formObject.CreatedBy,
              CreatedTime:
                formObject &&
                formObject.CreatedTime &&
                moment(formObject.CreatedTime).format('YYYY-MM-DD HH:mm:ss'),
              Comments: formObject && formObject.Comments,
              UseCaseName: formObject && formObject.UseCaseName,
              Description: formObject && formObject.Description,
              Attachments: formObject && formObject.Attachments
            });
          const response = await GetUseCase(APIList.getList, useCaseLevel && useCaseLevel[useCaseLevel.length - 1], 'Prediction');
          const response1 = await GetUseCase(APIList.getList, useCaseLevel && useCaseLevel[useCaseLevel.length - 1], 'Analysis');
          let AnalyticsId = useCaseLevel && useCaseLevel[useCaseLevel.length - 1];
          
          setBreadcrumbList(formObject && formObject.Path);
        //  setLastBreadcrumb('usecase');
          setAnalyticsId(AnalyticsId);
          setPredictionDatasource(response && Array.isArray(response) ? response : []);
          setAnalysisDatasource(response1 && Array.isArray(response1) ? response1 : []);
          setFormObject(formObject);
        }
      } else {
        let path = props && props.location && props.location.state && props.location.state.breadcrumbList;
        const data = [
          {
            title: 'UseCase',
            key: 'usecase',
            type: 'usecase'
          }
        ];

        const PathList = path && path.concat(data);
        setBreadcrumbList(PathList);
        const obj = {
          Title: null,
          Id: null,
          RelatedTags: [],
          CreatedBy:
            props &&
            props.userProfile &&
            props.userProfile.user &&
            props.userProfile.user.Id,
          CreatedTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          Comments: [],
          UseCaseName: null,
          Description: null,
          Attachments: []
        };
        hForm.current &&
          hForm.current.setFieldsValue({
            CreatedBy:
              props &&
              props.userProfile &&
              props.userProfile.user &&
              props.userProfile.user.Id,
            CreatedTime: moment().format('YYYY-MM-DD HH:mm:ss')
          });
        
        setFormObject(obj);
      }

      const list = await getUserList();
      let relatedTags = await getRelatedTags();
      //setUsecaseName(useCaseLevel && useCaseLevel && useCaseLevel[useCaseLevel.length - 1]);
      setUsers(list);
      setRelatedTags(relatedTags);
    }
  };

 const  translation = (keyword) => {
  const {translationCache} = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const changeOnBreadCrumb = async (breadCrumb, e, index) => {
    const value = [...breadcrumbList];
    const data = value.splice(0, index + 1);

    const dataVal = data[data.length - 1];
    if (dataVal && dataVal.type === 'home') {
      navigate('/rubus/RubusAnalytics/home');
    }
  };

  const editRecordPrediction = async (record) => {
    navigate(
      `/rubus/RubusAnalytics/Tasks/${record.Id}?AnalyticsId=${formObject.Id}&Type=Prediction`
    );

  };
  const editRecordAnalysis =  (record) => {
    navigate(
      `/rubus/RubusAnalytics/Tasks/${record.Id}?AnalyticsId=${formObject.Id}&Type=Analysis`
    );
  };

  const addAnalysisTask = () => {
    navigate(
      `/rubus/RubusAnalytics/Tasks/New?AnalyticsId=${formObject.Id}&Type=Analysis`,
      {
        state: {
          breadcrumbList: breadcrumbList
        }
      });
  };
  const addPredictionTask = () => {
    navigate(
      `/rubus/RubusAnalytics/Tasks/New?AnalyticsId=${formObject.Id}&Type=Prediction`,
      {
        state: {
          breadcrumbList: breadcrumbList
        }
      });
  };

  const onFinish = async () => {
    const data = hForm.current && hForm.current.getFieldsValue();
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async () => {
          const payload = {
            // ...values,
            ...data,
            Id: formObject && formObject.Id,
            Comments: formObject && formObject.Comments,
            Attachments: formObject && formObject.Attachments,
            CreatedTime:
              data &&
              data.CreatedTime &&
              moment(data.CreatedTime).utc().format('YYYY-MM-DD HH:mm:ss')
          };
          if (formObject && formObject.Id) {
            // payload.Attachments = formObject.Attachments;
            const UpdateResponse = await FormUpdate(payload, APIList.Update);

            if (UpdateResponse && UpdateResponse.status === 200) {
              message.success(UpdateResponse && UpdateResponse.data && UpdateResponse.data.message);
              const editData = await editList(UpdateResponse.data.Id);
              hForm.current.setFieldsValue({
                Title: editData && editData.Title,
                Id: editData && editData.Id,
                RelatedTags: editData && editData.RelatedTags,
                CreatedBy: editData && editData.CreatedBy,
                CreatedTime:
                  editData &&
                  editData.CreatedTime &&
                  moment(editData.CreatedTime).format('YYYY-MM-DD HH:mm:ss'),
                Comments: editData && editData.Comments,
                UseCaseName: editData && editData.UseCaseName,
                Description: editData && editData.Description,
                Attachments: editData && editData.Attachments
              });
              navigate(
                `/rubus/RubusAnalytics/usecase/${editData.Id}`,
              );
             const response = await GetUseCase(
                APIList.getList,
                UpdateResponse.data.Id,
                'Prediction'
              );
             const response1 = await GetUseCase(APIList.getList, UpdateResponse.data.Id, 'Analysis');

              setBreadcrumbList(editData && editData.Path);
             // setLastBreadcrumb('usecase');
              setFormObject(editData);
              setAnalyticsId(editData && editData.Id);
              setPredictionDatasource(response && Array.isArray(response) ? response : []);
              setAnalysisDatasource(response1 && Array.isArray(response1) ? response1 : []);

            } else {
              message.error(UpdateResponse && UpdateResponse.data && UpdateResponse.data.message);
            }
          } else {
            const createResponse = await FormSubmission(payload, APIList.Create);
            if (createResponse && createResponse.status === 200) {
              message.success(createResponse && createResponse.data && createResponse.data.message);
              const editData = await editList(createResponse.data.Id);
              hForm.current &&
                hForm.current.setFieldsValue({
                  Title: editData && editData.Title,
                  Id: editData && editData.Id,
                  RelatedTags: editData && editData.RelatedTags,
                  CreatedBy: editData && editData.CreatedBy,
                  CreatedTime:
                    editData &&
                    editData.CreatedTime &&
                    moment(editData.CreatedTime).format('YYYY-MM-DD HH:mm:ss'),
                  Comments: editData && editData.Comments,
                  UseCaseName: editData && editData.UseCaseName,
                  Description: editData && editData.Description,
                  Attachments: editData && editData.Attachments
                });
              navigate(
                `/rubus/RubusAnalytics/usecase/${editData.Id}`
              );

              const response = await GetUseCase(
                APIList.getList,
                createResponse.data.Id,
                'Prediction'
              );
              const response1 = await GetUseCase(APIList.getList, createResponse.data.Id, 'Analysis');

              setBreadcrumbList(editData && editData.Path);
             // setLastBreadcrumb('usecase');
              setFormObject(editData);
              setAnalyticsId(editData && editData.Id);
              setPredictionDatasource(response && Array.isArray(response) ? response : []);
              setAnalysisDatasource(response1 && Array.isArray(response1) ? response1 : []);
            } else {
              message.error(createResponse && createResponse.data && createResponse.data.message);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };
 const editList = async (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const object = {
      method: 'GET',
      url: `${APIList.getListUsecase}?SiteId=${siteId}&Id=${Id}&Type=Usecase`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(object)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const fileUpload = (info, key, index) => {
    // let formObject = this.hForm.current.getFieldsValue();
    if (info.file.status === 'done') {
      const id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      const Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject && formObject[key] && formObject[key][index]) {
        if (formObject[key][index]['Attachments']) {
          formObject[key][index]['Attachments'] =
            formObject &&
              formObject[key] &&
              formObject[key][index] &&
              formObject[key][index]['Attachments']
              ? formObject[key][index]['Attachments']
              : [];

          formObject[key][index]['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject[key][index]['Attachments'] = [];
          formObject[key][index]['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments']
              ? formObject['Attachments']
              : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      }
      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const useCaseModalClose = () => {
    setUseCaseModalVisible(false);
  };

  const SubmitComments = (value, key, index) => {
    // let formObject = this.hForm.current.getFieldValue();
  
    if (formObject && formObject[key] && formObject[key][index]) {
      if (formObject[key][index]['Comments'] !== undefined) {
        formObject[key][index]['Comments'].push(
          ...value.filter((item) => {
            return item.Id === undefined;
          })
        );
        formObject[key][index]['Comments'] = formObject[key][index]['Comments'].filter(
          (obj, Index) => {
            return (
              Index ===
              formObject[key][index]['Comments'].findIndex((o) => obj.Comment === o.Comment)
            );
          }
        );
      } else {
        formObject[key][index]['Comments'] = value;
      }
    } else {
      if (formObject && formObject['Comments'] && formObject['Comments'] !== undefined) {
        formObject['Comments'].push(
          ...value.filter((item) => {
            return item.Id === undefined;
          })
        );
        formObject['Comments'] = formObject['Comments'].filter((obj, Index) => {
          return Index === formObject['Comments'].findIndex((o) => obj.Comment === o.Comment);
        });
      } else {
        formObject['Comments'] = value;
      }
    }
    setFormObject(formObject);
    setUseCaseModalVisible(false);
  };

  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const beforeUpload = () => {
    const reader = new FileReader();
    reader.onload = () => { 
     // setFileName(file.name);
    };
  };
  // const editRecordAnalysisHandler = (record) => {
  //   editRecordAnalysis(record);
  // };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
 
    const userName =
      props &&
      props.userProfile &&
      props.userProfile.user &&
      props.userProfile.user.Id;
    const UseCaseColumns = [
      {
        title: 'File',
        dataIndex: 'file',
        key: 'file',
        align: 'center'
      },
      {
        title: 'Action',
        width: '600',
        align: 'center',
        render: (text, record) => (
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div style={{ marginLeft: '-25px' }}>
                <a href={`${IPAddress.LOCAL}/api/IOTAAttachments/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
        )
      }
    ];
    const PredictionColumns = [
      {
        title: translation('Prediction Task'),
        dataIndex: 'TaskName',
        key: 'TaskName',
        ...getColumnSearchProps('TaskName')
      },
      {
        title: translation('Description'),
        dataIndex: 'Description',
        key: 'Description'
      },
      {
        title: translation('CreatedBy'),
        dataIndex: 'CreatedName',
        key: 'CreatedName'
      },
      {
        title: translation('CreatedTime'),
        dataIndex: 'CreatedTime',
        key: 'CreatedTime',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Action'),
        width: '600',
        render: (text, record) => (
          <>
            <Button
              style={{ marginRight: '5px' }}

              onClick={() => {
                editRecordPrediction(record);
              }}
              
            >
              <Tooltip title={translation('Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
          </>
        )
      }
    ];

    const AnalysisColumns = [
      {
        title: translation('Analysis Task'),
        dataIndex: 'TaskName',
        key: 'TaskName',
        ...getColumnSearchProps('TaskName')
      },
      {
        title: translation('Description'),
        dataIndex: 'Description',
        key: 'Description'
      },
      {
        title: translation('CreatedBy'),
        dataIndex: 'CreatedName',
        key: 'CreatedName'
      },
      {
        title: translation('CreatedTime'),
        dataIndex: 'CreatedTime',
        key: 'CreatedTime',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Action'),
        width: '600',
        render: ( record) => (
          <>
            <Button
              style={{ marginRight: '5px' }}

              onClick={()=>editRecordAnalysis(record)}
              
              
            >
              <Tooltip title={translation('Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
          </>
        )
      }
    ];

    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const formItemLayout = { width: '100%', flex: '50%' };
   
    const items = [{
      key: '1',
      label: 'Prediction Tasks',
      children: (
        <div>
          {formObject && formObject.Id && formObject.Id !== undefined ? (
            <div style={{ float: 'right' }}>
              <Tooltip title={translation('Add Prediction Task')}>
                <PlusOutlined
                  onClick={addPredictionTask}
                  style={{
                    
                    color: 'rgb(255, 108, 0)',
                    marginLeft: '10px',
                    paddingBottom: '20px',
                    paddingRight: '20px'
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          <div>
            <StyledTable size="small"
              dataSource={predictionDatasource ? predictionDatasource : []}
              columns={PredictionColumns}
            />
          </div>
        </div>
      ),
    }, {
      key: '2',
      label: 'Analysis Tasks',
      children: (
        <div>
          {formObject && formObject.Id && formObject.Id !== undefined ? (
            <div style={{ float: 'right' }}>
              <Tooltip title={translation('Add Analysis Task')}>
                <PlusOutlined
                  onClick={addAnalysisTask}
                  style={{
                    
                    color: 'rgb(255, 108, 0)',
                    marginLeft: '10px',
                    paddingBottom: '20px',
                    paddingRight: '20px'
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          <div>
            <StyledTable size="small"
              dataSource={analysisDatasource ? analysisDatasource : []}
              columns={AnalysisColumns}
            />
          </div>
        </div>
      ),
    }];
    return (
      <>
        <div
          style={{
            margin: '10px'
          }}
        >
          <Breadcrumb
            style={{
              padding: '20px 0px 10px 35px',
              color: 'white',
              fontWeight: '800'
            }}
            separator=">"
            className="_Bredacrumb_"
          >
            {breadcrumbList &&
              Array.isArray(breadcrumbList) &&
              breadcrumbList.map((breadcrumb, index) => {
                if (
                  breadcrumb &&
                  breadcrumb.type &&
                  breadcrumb.type === 'home' &&
                  breadcrumbList.length === 1
                ) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {''}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.type && breadcrumb.type === 'home') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if ((breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') &&
                  (breadcrumb && breadcrumb.Id)) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/${breadcrumb.Id}?AnalyticsId=${analyticsId}&Type=${Type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/New?AnalyticsId=${formObject.Id}&Type=${breadcrumb.type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.Id) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/${breadcrumb.Id}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/New`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
          </Breadcrumb>
          {/* {lastBreadcrumb && lastBreadcrumb !== 'usecase' ?
              <div>{this.renderForm(lastBreadcrumb)}</div> : */}
          <>
            <Form 
              name="Training Jobs"
              theme={themeSettings}
              ref={hForm}
              onFinish={onFinish}
              onKeyDown={(e) => {
                e.key === 'Enter' && e.preventDefault();
              }}
              initialValues={formObject || {}}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              labelWrap
              wrapperCol={{ flex: 1 }}
            // validateMessages={validateMessages}
            >
              <div style={{ marginTop: '24px', display: 'flex', flexWrap: 'wrap' }}>

                <Form.Item
                  label="Title"
                  // labelCol={{ flex: '200px' }}
                  name={'Title'}
                  style={formItemLayout}
                  rules={[{ required: true, message: 'Please Provide Title' }]}
                >
                  <Input
                    style={{ width: '70%' }}
                    maxLength={10000}
                    
                    placeholder="Input Title"
                  />
                </Form.Item>

                <Form.Item
                  label="Related Tags"
                  name={'RelatedTags'}
                  placeholder="Select Tags"
                  style={formItemLayout}
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    placeholder="Search RelatedTags"
                    style={{ width: '70%' }}
                  >
                    {relatedTags&&
                      Array.isArray(relatedTags) &&
                      relatedTags.map((item, index) => {
                        return (
                          <Select.Option key={index} value={item.Code}>
                            {item.Code}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="UseCaseName"
                  name={'UseCaseName'}
                  rules={[{ required: true, message: 'Please Provide UseCase' }]}
                  style={formItemLayout}
                >
                  <TextArea
                    style={{
                      height: 100,
                      width: '70%'
                    }}
                    maxLength={10000}
                    placeholder="Input UseCaseName"
                  />
                </Form.Item>
                <Form.Item
                  label="Functional Description"
                  name={'Description'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide FunctionalDescription'
                    }
                  ]}
                >
                  <TextArea
                    maxLength={10000}
                    style={{
                      height: 100,
                      width: '70%'
                    }}
                    placeholder="Input FunctionalDescription"
                  />
                </Form.Item>
                <Form.Item style={formItemLayout} name="Attachments" label="Attachments">
                  <div>
                    <Select
                      
                      style={{ width: '70%' }}
                      placeholder={'Add/View Attachments'}
                      onChange={(e) => handleClick(e)}
                    >
                      <Select.Option key={'View Attachments'} value={'View Attachments'}>
                        View Attachments
                      </Select.Option>
                      <Select.Option key={'Add New Attachments'} value={'Add New Attachments'}>
                        Add New Attachments
                      </Select.Option>
                    </Select>
                    <Upload
                      // accept="text/csv"
                      multiple={true}
                      beforeUpload={beforeUpload}
                      // beforeUpload={this.filebeforeUpload}
                      // ref={this.myRef}
                      onChange={(info) => fileUpload(info)}
                      action={`${ANALYTICS.FileUpload}?SiteId=${siteId}&Type=${'UseCase'}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                        <UploadOutlined /> Upload
                      </Button>
                    </Upload>
                    <Drawer
                      title="UseCase Uploaded Files"
                      open={showusecasedownloadModal}
                      width={600}
                      onOk={() => setShowusecasedownloadModal(false)}
                      onClose={() => setShowusecasedownloadModal(false)}
                    >
                      <StyledTable size="small"
                        className="UseCaseUploadFilesTables"
                        columns={UseCaseColumns}
                        dataSource={
                          formObject &&
                            formObject.Attachments &&
                            Array.isArray(formObject.Attachments) &&
                            formObject.Attachments
                            ? [...formObject.Attachments]
                            : []
                        }
                      />
                      {/* </StyledTable> */}
                    </Drawer>
                  </div>
                </Form.Item>

                <Form.Item style={formItemLayout} label="Comments" name={'Comments'}>
                  <div>
                    <Tooltip
                      placement="topLeft"
                      color={'red'}
                      title="Click Here To Add Your Comments"
                    >
                      <Badge
                        count={formObject && formObject['Comments'] && formObject['Comments'].length}
                      >
                        <Button
                          style={{ background: '#eabe6f', color: 'black' }}
                          onClick={() => setUseCaseModalVisible(true)}
                        >
                          <CommentOutlined />
                          Add/View Comments
                        </Button>
                      </Badge>
                    </Tooltip>
                    {useCaseModalVisible && useCaseModalVisible === true ? (
                      <CommentsForm
                        Comments={
                          formObject && formObject['Comments'] && formObject['Comments'] !== undefined
                            ? [...formObject['Comments']]
                            : []
                        }
                        Title={'UseCase Comments'}
                        visible={useCaseModalVisible}
                        modalClose={useCaseModalClose}
                        user={userName}
                        submitComments={SubmitComments}
                      />
                    ) : null}
                  </div>
                </Form.Item>
                <Form.Item style={formItemLayout} label="Created By" name={'CreatedBy'}>
                  <Select
                    disabled
                    value={
                      props &&
                      props.userProfile &&
                      props.userProfile.user &&
                      props.userProfile.user.Id
                    }
                    suffix={<UserOutlined />}
                    placeholder="Select CreatedBy"
                    style={{ width: '70%' }}
                  >
                    {users &&
                      Array.isArray(users) &&
                      users.map((item, index) => {
                        return (
                          <Select.Option key={index} value={item.Id}>
                            {item.FirstName}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item style={formItemLayout} label="Created Date" name={'CreatedTime'}>
                  <Input
                    disabled
                    
                    style={{ width: '70%' }}
                    placeholder="CreatedDate"
                    suffix={<FieldTimeOutlined />}
                  />
                </Form.Item>
              </div>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={onFinish}>
                    Submit
                  </Button>
                </Form.Item>
              </div>
            </Form>


            <div>
              <StyledTab
                theme={LightTheme}
                defaultActiveKey="1"
                type="card"
                activeKey={activeKey}
                onChange={async (activeKey) => {
                  if (activeKey === '2') {
                    setActiveKey(activeKey);
                  }
                  if (activeKey === '1') {
                    setActiveKey(activeKey);

                  }
                  setActiveKey(activeKey);

                }}
                items={items}
              />
            </div>
          </>
          {/* } */}
        </div>
      </>
    );
  
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(UseCase);
